import { ActionPlanType } from './../../enums/ActionPlanType';

const getLabel: Record<ActionPlanType, () => string> = {
  training: () => 'Training',
  eLearning: () => 'E-learning',
  hiring: () => 'Hiring',
  purchasing: () => 'Purchasing',
  updatingSop: () => 'Updating SOP',
  other: () => 'Other',
};

export function translateActionPlanTypeLabel (type: ActionPlanType) {
  if (!type || !getLabel[type]) {
    return '';
  }
  return getLabel[type]();
}
